import { createUseStyles } from 'react-jss';
import { colors } from '@insurancemenu/imenu-components-lib';
import { ComponentStylesProps } from '@insurancemenu/imenu-components-lib/dist/types';
import { InCellDivisionBlockProps } from './index';

const styles: ComponentStylesProps<InCellDivisionBlockProps> = {
  inCellDivision: (props) => ({
    boxSizing: 'border-box',
    padding: {
      bottom: '0.8rem',
    },
    marginBottom: '0.8rem',
    maxWidth: props.maxWidth || '100%',
    '&:last-of-type': { border: 'none', marginBottom: 0, paddingBottom: 0 },
  }),
  withBorder: {
    borderBottom: `1px solid ${colors.neutral[200]}`,
  },
};

const createStyles = createUseStyles(styles);

export { createStyles };
